export enum NavBarType {
  NotLoggedIn,
  General,
  AppBuilder,
  AppBuilderPreview,
  None
}
